import type { IndexProduct } from '@/domains/products/types/models/IndexProduct.types'

/**
 * Whether any variant of this product is a pack.
 *
 * A product is not a variant: one packed variant among five plain ones wears the badge, which
 * is the same reading the `composition` filter answers with — so a filtered page cannot show a
 * row whose badge disagrees with the chip that found it.
 */
const isPack = (product: IndexProduct): boolean => (product.variants ?? []).some(variant => variant.is_pack === true)

export { isPack }
